export default "__VITE_ASSET__BnM$kExx__"